import { homeRoute, localLoginRoute } from './../../core/routing/route-names';
import { AuthService } from '../services/auth.service';
import { OnInit, Component, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { SpinnerService } from '../spinner/spinner.service';
import { TranslateModule } from '@ngx-translate/core';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { EventMessage, RedirectRequest, EventType, AuthenticationResult } from '@azure/msal-browser';
import { Observable, Subject, filter } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [TranslateModule, TitleBarComponent]
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalAuthService: MsalService,
    private msalBroadcastService: MsalBroadcastService) { }

  ngOnInit() {
    this.msalAuthService.handleRedirectObservable().subscribe();
    //this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

    this.msalAuthService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.msalAuthService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        }
      });

    this.spinnerService.hide();
    if (this.authService.isUserLoggedIn()) {
      this.router.navigate([homeRoute]);
    }
  }

  public selectLocalLogin(): void {
    this.router.navigate([localLoginRoute]);
  }

  public selectSamlLogin() {
    this.getMsalLoginObservable().subscribe((result) => {
      this.msalAuthService.instance.setActiveAccount(result.account);
      this.getBearerTokenAfterAzureLogin();
    });
  }

  private getBearerTokenAfterAzureLogin() {
    let activeAccount = this.msalAuthService.instance.getActiveAccount();
    if (!activeAccount) {
      return;
    }
  
    this.authService.loginAfterAzureMFA().subscribe({
      next: result => {
        this.loading = false;
        if (result) {
          if (this.authService.redirectUrl) {
            this.router.navigateByUrl(this.authService.redirectUrl);
          } else {
            this.router.navigate([homeRoute]);
          }
        }
      },
      error: error => {
        this.loading = false;
        this.toastService.showApiException(error, 'i18n.core.messages.login.title', 'i18n.core.messages.login.message');
        setTimeout(() => {
          this.msalAuthService.logoutRedirect();
        }, 0);
      }
    });
  }

  private getMsalLoginObservable(): Observable<AuthenticationResult> {
    if (this.msalGuardConfig.authRequest){
      return this.msalAuthService.loginPopup({...this.msalGuardConfig.authRequest} as RedirectRequest);
    }
    return this.msalAuthService.loginPopup();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
